export const STC_ADMIN = '/stc-admin' as const
export const STC_LISTENER = '/stc-listener' as const
export const STC_CATEGORY = '/stc-category' as const
export const STC_STUDY = `${STC_LISTENER}/:course_id/:chapter_id?/:topic_id?/:step_id?` as const
export const STC_CREATE = `${STC_ADMIN}/build/:course_id/:chapter_id?/:topic_id?/:step_id?` as const
export const STC_COURSE = '/stc-course/:course_id' as const
export const STC_TOPIC = '/stc-topic/:course_id/:topic_id' as const
